<header class="bg-secondary-light px-4" style="height: 64px">
  <div class="row g-0 h-100 justify-content-between align-items-center flex-nowrap">
    <div class="col mw-0">
      <div class="d-flex align-items-center">
        <mwe-header-logo-image aria-hidden="true" />
        <div class="fw-bold mb-0 text-white text-truncate" data-test="mwe-wizard-header-label" [translate]="titleKey"></div>
      </div>
    </div>
    <div class="col-auto">
      @if (isClosingAllowed) {
        <mwe-button
          color="white"
          category="tertiary"
          size="sm"
          [isIconBtn]="true"
          buttonId="mwe-wizard-header-close"
          [title]="'shared.wizard.header.cancelAria' | translate: { name: (titleKey | translate) }"
          (clicked)="cancelOnHeader()"
        >
          <i class="fas fa-times" aria-hidden="true"></i>
        </mwe-button>
      }
    </div>
  </div>
</header>
